import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/index';
import Grid from 'material-ui/Grid';
import styled from 'styled-components';

const Footer = styled.div`
  background: #0066ff;
  color: #fff;
  font-weight: 400;
  padding: 40px 30px;
  font-size: 14px;

  h3 {
    color: #fff;
    margin-top: 0;
  }
  p {
    line-height: 1.4em;
  }
  ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    margin-bottom: 10px;
    cursor: pointer;
    color: #fff;

    &:hover {
      color: rgba(254,219,151,1);
    }
  }
`;
const Content = styled.div`
  padding: 40px 40px 30px 20px;
`;

class FooterLinks extends PureComponent {
  constructor(props) {
    super(props);
  }
  handleDirectLink(lat, lng, zoom) {
    const { changeMap, onShowInfo } = this.props;
    onShowInfo(false);
    changeMap({
      center: [lat, lng],
      zoom: zoom
    });
  }
  render() {
    return (
      <Footer>
        <Grid container>
          <Grid item xs={12}>
            <h3>California Beach Water Quality:</h3>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} md={6}>
            <ul>
              <li onClick={() => this.handleDirectLink(33.90179899999997, -118.42200300000002, 14)}>El Porto Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.919028632189594, -118.4257496514416, 13)}>El Segundo Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.657163540804945, -117.9963769109583, 13)}>Huntington Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.919028632189594, -118.4257496514416, 13)}>Laguna Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.75629193700284, -118.1625471938305, 13)}>Long Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.98851031985289, -118.43026518014813, 10)}>Los Angeles Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(34.101813256071296, -118.76541208958417, 11)}>Malibu Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.88114193140619, -118.42501493254565, 13)}>Manhattan Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.83743835994528, -118.39547298540208, 13)}>Redondo Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.41735000000001, -117.61892999999998, 13)}>San Clemente Beach Water Quality</li>
            </ul>
          </Grid>
          <Grid item xs={12} md={6}>
            <ul>
              <li onClick={() => this.handleDirectLink(37.79627871428572, -122.49059358719046, 11)}>San Francisco Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(37.39758178788702, -122.07277613653463, 10)}>San Jose Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(34.44249805491184, -119.6649179636147, 11)}>Santa Barbara Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(36.96263399999998, -122.020309, 14)}>Santa Cruz Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(34.014531000000005, -118.50423, 14)}>Santa Monica Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.739604, -118.115318, 14)}>Seal Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.8815863832463, -118.40278854556715, 14)}>South Bay Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.819824, -118.391073, 14)}>Torrance Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(33.990176508639934, -118.47307704597381, 14)}>Venice Beach Water Quality</li>
              <li onClick={() => this.handleDirectLink(34.268123312293255, -119.28816709366089, 14)}>Ventura Beach Water Quality</li>
            </ul>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <p>Heal the Bay’s Beach Report Card website and app share the latest beach water quality information for popular beaches in California, Oregon and Washington.  Ocean water quality is a top concern for many different reasons.  People who live near the West Coast of the United States and frequently visit the beach to swim or surf, can see an increased risk of getting sick from contact with poor beach water quality.  Young children, pregnant women and older adults should limit exposure to poor ocean water quality because they are more vulnerable.  There are also economic reasons why beach water quality is important.  Coastal tourism and businesses rely on access to clean beaches, thriving ecosystems and healthy marine habitats.  It is important to monitor beach water quality to understand the impact of human behavior and pollution on the local marine environment in order to create better solutions.  Check out the Beach Report Card before you head out to the beach. Always obey official public advisories, warnings and signs at the beach. Just remember to practice safe swimming.</p>
          </Grid>
        </Grid>
      </Footer>
    );
  }
}
const mapStateToProps = state => {
  return {
    hoverId: state.brc.hoverId
  };
};

export default connect(mapStateToProps, {...Actions})(FooterLinks);


// WEBPACK FOOTER //
// ./src/components/static/FooterLinks.js